import Icon from '@/components/ui/AppIcon';

interface BookingStatusBadgeProps {
  status: 'pending' | 'confirmed' | 'completed' | 'cancelled';
  showIcon?: boolean;
}

const BookingStatusBadge = ({ status, showIcon = true }: BookingStatusBadgeProps) => {
  const statusConfig = {
    pending: {
      label: 'Pending',
      icon: 'ClockIcon',
      bgColor: 'bg-warning/10',
      textColor: 'text-warning',
      borderColor: 'border-warning/20',
    },
    confirmed: {
      label: 'Confirmed',
      icon: 'CheckCircleIcon',
      bgColor: 'bg-primary/10',
      textColor: 'text-primary',
      borderColor: 'border-primary/20',
    },
    completed: {
      label: 'Completed',
      icon: 'CheckBadgeIcon',
      bgColor: 'bg-success/10',
      textColor: 'text-success',
      borderColor: 'border-success/20',
    },
    cancelled: {
      label: 'Cancelled',
      icon: 'XCircleIcon',
      bgColor: 'bg-error/10',
      textColor: 'text-error',
      borderColor: 'border-error/20',
    },
  };

  const config = statusConfig[status];

  return (
    <span data-component-id="src/app/all-bookings-view/components/BookingStatusBadge.tsx:43:4" data-component-path="src/app/all-bookings-view/components/BookingStatusBadge.tsx" data-component-line="43" data-component-end-line="52" data-component-file="BookingStatusBadge.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
      className={`
        inline-flex items-center gap-1.5 px-3 py-1 rounded-full
        border font-caption font-medium text-xs
        ${config.bgColor} ${config.textColor} ${config.borderColor}
      `}
    >
      {showIcon && <Icon data-component-id="src/app/all-bookings-view/components/BookingStatusBadge.tsx:50:19" data-component-path="src/app/all-bookings-view/components/BookingStatusBadge.tsx" data-component-line="50" data-component-end-line="50" data-component-file="BookingStatusBadge.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={config.icon as any} size={14} />}
      {config.label}
    </span>
  );
};

export default BookingStatusBadge;
